import { coreApi } from '../api'

interface CrmResponse {
  data: {
    id: string
  }
}

const fetchData = async (cpf: string) => {
  const { data: response } = await coreApi.get<CrmResponse>(
    `/crm/customers?filter[query]=${cpf}`,
  )

  return {
    customer: {
      id: response.data.id,
    },
  }
}

export { fetchData }
